import styled from 'styled-components';

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.grayColor};
  display: flex;
  flex-direction: column;
  padding: 2em 2em 4em 2em;
  height: 100%;
  align-items: center;
  justify-content: center;
`;
